export default __webpack_public_path__ + "img/99f7d8d1d2637631c76fe7902351ddbf.svg";